<template>
    <Paper id="mipIframe" v-loading.fullscreen.lock="btnloading">
        <div v-if="moduleCode !== MCODE_WAREHOUSE_PERFORM">
            <el-button
                style="margin-bottom: 12px"
                size="mini"
                class="el-button"
                type="primary"
                @click="submitMip"
                :disabled="submitDisabled"
                :loading="btnloading"
                v-if="!(fdStatus === '20' || fdStatus === '40')">
                mip提交
            </el-button>
            <el-button
                style="margin-bottom: 12px"
                size="mini"
                class="el-button"
                type="primary"
                @click="submitMip"
                :loading="btnloading"
                v-else>
                传阅
            </el-button>
            <el-button size="mini" class="el-button" type="primary" @click="guide">分权指引</el-button>
        </div>
        <TenderResultUploadList
            ref="tenderResultUpload"
            v-if="['tenderResult'].includes(accuratePosition)"></TenderResultUploadList>
            <!-- 从成本及投标报价详情跳转，或从合同维护-商机信息跳转过来时才显示 -->
            <BidPriceInfo v-if="currentPath.includes('tenderCostDetails') || (currentPath.includes('contractUphold') && $route.query.projectCode)"></BidPriceInfo>
            <AttachmentCarQuitList v-if="from === 'attachmentCar'" :fdId="$route.query.processId"/>
        <!-- 供应商引入-MIP提交、特批申请 展示此信息块 -->
        <SupIntroduceAudit class="mip-sup-intro" v-if="[MCODE_MIP_APV, MCODE_SPECIAL_APV].includes(moduleCode)" :auditId="fdId" :moduleCode="moduleCode"/>
        <!-- 存储资源池-寻源过程-流程展示供应商信息 -->
        <SupplierTableAudit v-if="moduleCode === MCODE_SOURCING_APV" :auditId="fdId" />
        <!-- 供应商变更 展示此信息块 -->
        <SupChangeAudit v-if="moduleCode === MCODE_SUP_CHANGE" :auditId="fdId" />
        <!-- 供应商退出 展示此信息块 -->
        <SupQuitAudit v-if="moduleCode === MCODE_SUP_QUIT" :auditId="fdId" />
        <!-- 供应商黑名单 展示此信息块 -->
        <SupWhiteBlack v-if="[MCODE_WHITE_APV, MCODE_BLACK_APV].includes(moduleCode)" :auditId="fdId" :isWhite="moduleCode === MCODE_WHITE_APV" :isBlack="moduleCode === MCODE_BLACK_APV" />
        <!-- 招采计划 展示此信息块 -->
        <BidPlanApprovalTable v-if="moduleCode=== MCODE_BidPlan_APV" :auditId="fdId"/>
        <!-- 招采计划修改 展示此信息块 -->
        <BidPlanChangeAudit v-if="moduleCode=== MCODE_BIDPLAN_CHANGE" :fdId="fdId" :bidPlanId="$route.query.bidPlanId" />
        <!-- 物流园变更 无需展示此模块 -->
        <LeaseWhMipMsg v-if="moduleCode !== MCODE_WAREHOUSE_APV && moduleCode !== ''" :fdId="$route.query.processId || $route.query.mbpmFlowId" />
        <!-- 装卸人员工资确认流程表格 -->
        <SalaryProgressTable v-if="from === 'salary'" :fdId="$route.query.processId" :confirmCode="$route.query.confirmCode"/> 
        <!-- 绩效考核明细 展示此信息块 -->
        <PerformanceChangeInfo v-if="moduleCode === MCODE_PERFORMANCE" :auditId="fdId" />
        <!-- 绩效考核明细-申请废弃 展示此信息块 -->
        <AbandonAuditMsg v-if="moduleCode === MCODE_PF_ABANDON" :auditId="fdId" />
        <!-- 物流园变更 展示此信息块 -->
        <PhysicalStorageChangeAudit v-if="moduleCode === MCODE_WAREHOUSE_APV" :auditId="fdId" />
        <!-- 新供应商点检审批 展示此信息块 -->
        <NewSupCheckAudit v-if="moduleCode === MCODE_SPOT_CHECK" :auditId="fdId" :auditStatus="fdStatus" ref="nsaRef"  />
        <!-- 零担自营线路审批 展示此信息块 -->
        <LessThanAudit v-if="moduleCode === MCODE_LESS_THAN" :auditId="fdId" :ids="$route.query.routeIds"/>
        <!-- 财产险选中的数据 -->
        <PropertyInsrTable v-if="moduleCode === MCODE_INSURANCE" :fdId="fdId" />
        <!-- 仓储绩效 -->
        <WarehousePerform v-if="moduleCode === MCODE_WAREHOUSE_PERFORM" :fdId="fdId" @success="warehousePerformApprovalSuccess"/>
        <!-- 仓储寻源 展示此信息块 -->
        <WarehouseInfo v-if="moduleCode === MCODE_WH_SRC" :fdId="fdId" />
        <iframe ref="frameRef" class="ifr" :src="mipurl" />
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper'
import { createProcess, queryOneInstance } from '../../../api/annoMana.js'
import { getResourceFile } from '@/components/lots/floatHelp/api'
import { mapGetters } from 'vuex'
import { dictWithUrl } from '@/components/lots/api'
import {
    checkAllowTenderCost,
    queryFlowAuditIsRefuse,
    checkProjectBeforeUpdateNew,
} from '../../../api/tenderOffer/tenderCostDetails.js'
import TenderResultUploadList from './TenderResultUploadList'
import BidPriceInfo from './BidPriceInfo'
import AttachmentCarQuitList from './attachmentCarQuitList.vue'
import SupIntroduceAudit from '../../register/manage/keyData/detail/components/SupIntroduceAudit.vue'
import SupQuitAudit from '../../register/manage/keyData/detail/components/SupQuitAudit.vue'
import PhysicalStorageChangeAudit from '../../register/manage/keyData/physicalStorage/PhysicalStorageChangeAudit.vue'
import SupChangeAudit from '../../register/manage/keyData/detail/components/SupChangeAudit.vue'
import LessThanAudit from '../../register/manage/keyData/detail/components/LessThanAudit.vue'
import SupplierTableAudit from '../../storageSrcPool/warehouseSourceProcess/components/SupplierTableAudit.vue'
import SupWhiteBlack from '../../register/manage/aublackList/SupWhiteBlack.vue'
import LeaseWhMipMsg from '../../register/manage/keyData/physicalStorage/LeaseWhMipMsg.vue'
import SalaryProgressTable from '../../warehouseResourceManagement/loaderSalaryConfirm/progressTable.vue'
import BidPlanApprovalTable from '../../tendering/biddingProcurementPlan/BidPlanApprovalTable.vue'
import BidPlanChangeAudit from '../../tendering/biddingProcurementPlan/ChangeAudit.vue'
import PerformanceChangeInfo from '../../warehouseResourceManagement/performanceAssessDetail/PerformanceChangeInfo.vue'
import AbandonAuditMsg from '../../warehouseResourceManagement/performanceAssessDetail/AbandonAuditMsg.vue'
import NewSupCheckAudit from '../../resource/newSupCheckPool/NewSupCheckAudit.vue'
import PropertyInsrTable from '../../insurance/propertyInsurance/propertyInsrMaintn/progressTable.vue'
import WarehousePerform from './warehousePerform.vue'
import WarehouseInfo from '../../storageSrcPool/warehouseSourceProcess/components/WarehouseInfo.vue'

// 流程接口返回对应的 moduleCode
const MCODE_MIP_APV = 'srm_register_mip_approval' // 供应商引入-MIP提交
const MCODE_SPECIAL_APV = 'srm_register_special_approval' // 供应商引入-特批申请
const MCODE_SUP_CHANGE = 'srm_supplier_change_apply' // 供应商变更
const MCODE_SUP_QUIT = 'srm_supplier_quit' // 供应商退出
const MCODE_WHITE_APV = 'srm_register_white_mip_approval' // 供应商洗白
const MCODE_BLACK_APV = 'srm_register_black_mip_approval' // 供应商拉黑
const MCODE_BidPlan_APV = 'srm_bid_plan' // 招采计划
const MCODE_BIDPLAN_CHANGE = 'srm_bid_plan_change' // 招采计划修改
const MCODE_PERFORMANCE = 'warehousePerformanceAssessmentApproval' // 绩效考核明细
const MCODE_PF_ABANDON = 'warehousePerformanceDeprecateApproval' // 绩效考核明细-申请废弃
const MCODE_SOURCING_APV = 'srm_sourcing_load_and_unload_detail' // 存储资源池-寻源过程-供应商信息
const MCODE_WAREHOUSE_APV = 'srm_warehouse_change' // 物流园-变更申请
const MCODE_SPOT_CHECK = 'srm_su_spot_check' // 新供应商点检审批
const MCODE_LESS_THAN = 'common_route_is_self_manage' // 零担自营线路线路审批
const MCODE_INSURANCE = 'SRM_INSURANCE_MAINTAIN' // 财产险审批
const MCODE_WAREHOUSE_PERFORM = 'warehousePerformanceCorrectionApproval' // 仓储绩效整改
const MCODE_WH_SRC = 'srm_su_sourcing_pw' // 仓储寻源

export default {
    components: { Paper, TenderResultUploadList, BidPriceInfo, AttachmentCarQuitList, SupIntroduceAudit, SupQuitAudit, SupChangeAudit, SupWhiteBlack, LeaseWhMipMsg, WarehousePerform,
        SalaryProgressTable, BidPlanApprovalTable, BidPlanChangeAudit, PerformanceChangeInfo, AbandonAuditMsg, SupplierTableAudit,PhysicalStorageChangeAudit, NewSupCheckAudit, LessThanAudit, PropertyInsrTable,
        WarehouseInfo,
     },
    data() {
        return {
            btnloading: false,
            mipurl: '',
            fdStatus: '',
            messageObj: null,
            dictData: {},
            submitDisabled: false,
            isTenderCostProcess: false, // 是否成本及报价审批流程
            currentPath: '', // 提交流程后跳转的路由
            accuratePosition: '',
            from: '',
            fdId: '', // 当前流程 id

            moduleCode: '',
            MCODE_MIP_APV,
            MCODE_SPECIAL_APV,
            MCODE_SUP_CHANGE,
            MCODE_SUP_QUIT,
            MCODE_WHITE_APV,
            MCODE_BLACK_APV,
            MCODE_BidPlan_APV,
            MCODE_BIDPLAN_CHANGE,
            MCODE_PERFORMANCE,
            MCODE_PF_ABANDON,
            MCODE_SOURCING_APV,
            MCODE_WAREHOUSE_APV,
            MCODE_SPOT_CHECK,
            MCODE_LESS_THAN,
            MCODE_INSURANCE,
            MCODE_WAREHOUSE_PERFORM,
            MCODE_WH_SRC,
        }
    },
    async mounted() {
        this.currentPath = ''
        this.accuratePosition = ''
        this.from = this.$route.query.from || ''
        if (this.$route.query.path) {
            this.currentPath = this.$route.query.path
        }
        if (this.$route.query.accuratePosition) {
            this.accuratePosition = this.$route.query.accuratePosition
        }
        if (!this.$route.query.processId && !this.$route.query.mbpmFlowId) {
            this.$message.error('processId不能为空！')
            return
        }
        // if (this.$route.query.riskControl) {
        //     this.messageObj = this.$message({
        //         type: 'info',
        //         message: '审批前请先查看页面的企业风控信息后再审批',
        //         duration: 0,
        //         showClose: true,
        //     })
        // }
        window.addEventListener('message', this.messageFunc, false)
        await this.getDictData()
        this.queryOneInstanceFn()

        // 挂载完后滚动至顶部
        const mainDom = document.getElementsByClassName('el-main')
        if (mainDom && mainDom.length) {
            mainDom[0].scrollTo(0, 0)
        }
    },
    destroyed() {
        window.removeEventListener('message', this.messageFunc, false)
        if (this.messageObj) {
            this.messageObj.close()
        }
    },
    methods: {
        warehousePerformApprovalSuccess(){
            this.$router.push(`${this.$store.state.supplier?'/lsrm':''}/performanceAdjustment`)
        },
        messageFunc(event) {
            this.messageCallback(event)
        },
        async submitMip() {
            if (['tenderresult', 'tendermanagement'].includes(this.currentPath)) {
                this.getQueryFlowAuditIsRefuse()
            } else if (this.currentPath.includes('tenderCostDetails')) {
                // 从成本及投标报价过来的页面,需要添加校验接口
                const res = await checkProjectBeforeUpdateNew({ projectCode: this.$route.query.projectCode })
                if (!res) return;
                this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', '*')
            }
            else {
                this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', '*')
            }
        },
        getQueryFlowAuditIsRefuse() {
            let params = { fdId: this.$route.query.processId }
            this.btnloading = true;
            queryFlowAuditIsRefuse(params).then(res => {
                if (res && +res.code === 0) {
                    // 查询招标流程是否需要弹提示，true是驳回需要提示，false不需要
                    if (res.data) {
                        this.$confirm('请确定导入的降本信息是否准确，若不准确，请联系流程起草人重新导入', '提示', {
                            confirmButtonText: '确定',
                            showClose: false,
                            cancelButtonText: '取消',
                            type: 'warning',
                        })
                            .then(() => {
                                this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', '*')
                            })
                            .catch(() => {})
                    } else {
                        this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', '*')
                    }
                    this.btnloading = false;
                }
            }).finally(()=>{
                this.btnloading = false;
            })
        },

        queryOneInstanceFn() {
            queryOneInstance({ fdId: this.$route.query.processId || this.$route.query.mbpmFlowId, tenantCode: this.currentTenant.tenantCode }).then(
                res => {
                    this.pubulishMipFlag = false
                    if (res && +res.code === 0) {
                        this.fdId = res.data.fdId
                        this.fdStatus = res.data.auditStatus
                        // this.mipurl = res.data.extFrameUrl;
                        this.mipurl = `${res.data.extFrameUrl}&userCode=${this.user.userCode}&userName=${this.user.userName}${res.data.moduleCode === MCODE_WAREHOUSE_PERFORM ? '&hiddenMenu=1' : ''}`
                        // 判断当前流程是否为成本及报价审批流程
                        this.isTenderCostProcess = res.data.templateId === this.dictData.SRM_IFLOW_TEMP_ID.TENDER_COST
                        this.moduleCode = res.data.moduleCode
                    }
                },
            ).catch(err => {})
        },
        async messageCallback(event) {
            if (event.data && event.data.data && event.data.success) {
                const params = event.data.data
                params.formInstanceId = this.$route.query.formInstanceId
                params.tenantCode = this.currentTenant.tenantCode
                params.currentApplicationCode = this.applicationCode
                // 需要formData {} 参数的，自己手动传
                params.formParam.formData = this.$route.query.formData ? this.$route.query.formData : null
                if (!this.submitValidate(params)) {
                    return false
                }
                this.btnloading = true
                // 当前是成本及报价审批流程，且流程操作是提交或通过时，进行校验
                if (
                    this.isTenderCostProcess &&
                    ['draft_submit', 'handler_pass'].includes(params.processParam.operationType)
                ) {
                    const checkTcRes = await checkAllowTenderCost({ projectCode: this.$route.query.projectCode })
                    if (!checkTcRes || +checkTcRes.code !== 0) {
                        this.btnloading = false
                        return false
                    }
                }
                createProcess(params)
                    .then(res => {
                        if (+res.code === 0) {
                            if (params.processParam.operationType === 'handler_communicate') {
                                //选项为沟通时，提交后MIP提交按钮需置灰
                                this.submitDisabled = true
                            }
                            this.btnloading = true
                            setTimeout(() => {
                                this.btnloading = false
                                if (this.$route.query.isBack) {
                                    this.$router.push({
                                        name: this.$route.query.path,
                                        query: { bidNo: this.$route.query.formInstanceId },
                                    })
                                } else {
                                    if(this.$route.query.path){
                                        this.$router.push(this.$route.query.path)
                                    }else{
                                        location.reload()
                                    }
                                }
                            }, '2000')
                        }
                    })
                    .finally(() => {
                        this.btnloading = false
                    })
            }
        },
        guide() {
            getResourceFile('RE2202009030030').then(res => {
                if (res && res.data.list.length > 0) {
                    const url = res.data.list[0].wordDownloadUrl
                        ? res.data.list[0].wordDownloadUrl
                        : res.data.list[0].pdfDownloadUrl
                    if (url) {
                        const a = document.createElement('a')
                        a.href = url
                        a.click()
                    } else {
                        this.$message.warning('暂无可下载文档，请联系管理员维护')
                    }
                } else {
                    this.$message.warning('暂无可下载文档，请联系管理员维护')
                }
            })
        },
        getDictData() {
            return dictWithUrl('SRM_IFLOW_TEMP_ID')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.dictData = res.data
                    }
                })
                .catch(err => {})
        },
        submitValidate(params) {
            let valid = true
            try {
                // 新供应商点检审批校验，不是提交废弃就点检附件必传
                if (
                    this.moduleCode === MCODE_SPOT_CHECK && 
                    params.processParam.operationType !== 'draft_abandon' &&
                    (!this.$refs.nsaRef || !this.$refs.nsaRef.uploadValidate())
                ) {
                    this.$message.warning('请上传点检附件后再提交审批')
                    valid = false
                }
            } catch (e) {}
            return valid
        },
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'user']),
    },
}
</script>

<style lang="less">
.ifr {
    width: 100%;
    height: 100vh;
    border: none;
}

.mip-sup-intro{
    .sub-title{
        font-size: 16px;
        font-weight: normal;
    }
}
</style>
